import Vue from 'vue';
import App from './App.vue';
import router from './router';
// import Prism from 'prismjs';
import L from 'leaflet';
import AutoComplete from 'primevue/autocomplete';
import Accordion from 'primevue/accordion';
import AccordionTab from 'primevue/accordiontab';
import Button from 'primevue/button';
import Breadcrumb from 'primevue/breadcrumb';
import Calendar from 'primevue/calendar';
import Card from 'primevue/card';
import Carousel from 'primevue/carousel';
import Chart from 'primevue/chart';
import Checkbox from 'primevue/checkbox';
import Chips from 'primevue/chips';
import Column from 'primevue/column';
import ColumnGroup from 'primevue/columngroup';
import ColorPicker from 'primevue/colorpicker';
import ContextMenu from 'primevue/contextmenu';
import DataTable from 'primevue/datatable';
import DataView from 'primevue/dataview';
import DataViewLayoutOptions from 'primevue/dataviewlayoutoptions';
import Dialog from 'primevue/dialog';
import Dropdown from 'primevue/dropdown';
import Fieldset from 'primevue/fieldset';
import FileUpload from 'primevue/fileupload';
import FullCalendar from 'primevue/fullcalendar';
import InlineMessage from 'primevue/inlinemessage';
import InputMask from 'primevue/inputmask';
import InputNumber from 'primevue/inputnumber';
import InputSwitch from 'primevue/inputswitch';
import InputText from 'primevue/inputtext';
import Listbox from 'primevue/listbox';
import MegaMenu from 'primevue/megamenu';
import Menu from 'primevue/menu';
import Menubar from 'primevue/menubar';
import Message from 'primevue/message';
import MultiSelect from 'primevue/multiselect';
import OrderList from 'primevue/orderlist';
import OrganizationChart from 'primevue/organizationchart';
import OverlayPanel from 'primevue/overlaypanel';
import Paginator from 'primevue/paginator';
import Panel from 'primevue/panel';
import PanelMenu from 'primevue/panelmenu';
import Password from 'primevue/password';
import PickList from 'primevue/picklist';
import ProgressBar from 'primevue/progressbar';
import Rating from 'primevue/rating';
import RadioButton from 'primevue/radiobutton';
import Ripple from 'primevue/ripple';
import Row from 'primevue/row';
import SelectButton from 'primevue/selectbutton';
import Slider from 'primevue/slider';
import Sidebar from 'primevue/sidebar';
import SplitButton from 'primevue/splitbutton';
import Steps from 'primevue/steps';
import TabMenu from 'primevue/tabmenu';
import TieredMenu from 'primevue/tieredmenu';
import Textarea from 'primevue/textarea';
import Toast from 'primevue/toast';
import ToastService from 'primevue/toastservice';
import Toolbar from 'primevue/toolbar';
import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';
import ToggleButton from 'primevue/togglebutton';
import Tooltip from 'primevue/tooltip';
import Tree from 'primevue/tree';
import TreeTable from 'primevue/treetable';
import TriStateCheckbox from 'primevue/tristatecheckbox';
import ProgressSpinner from 'primevue/progressspinner';
import Galleria from 'primevue/galleria';
Vue.component('Galleria', Galleria);
// i18n
import i18n from './i18n/i18n';

import 'primevue/resources/primevue.min.css';
import 'primeflex/primeflex.css';
import 'primeicons/primeicons.css';
import '@fullcalendar/core/main.min.css';
import '@fullcalendar/daygrid/main.min.css';
import '@fullcalendar/timegrid/main.min.css';
import 'prismjs/themes/prism-coy.css';
//pdf
import jsPDF from 'jspdf';
Vue.component('jsPDF', jsPDF);

import autoTable from 'jspdf-autotable';
Vue.component('autoTable', autoTable);

//excel
import JsonExcel from 'vue-json-excel';
Vue.component('downloadExcel', JsonExcel);


// VueSimpleAlert
import VueSimpleAlert from 'vue-simple-alert';
Vue.use(VueSimpleAlert);

Vue.use(ToastService);
Vue.directive('Tooltip', Tooltip);
Vue.directive('ripple', Ripple);

Vue.prototype.$appState = Vue.observable({ inputStyle: 'outlined' });
Vue.prototype.$primevue = Vue.observable({ ripple: true });
import axios from 'axios';
Vue.prototype.$http = axios;

Vue.prototype.$url_service = 'https://www.bfrd199.com'; // prod
// Vue.prototype.$url_service = "http://localhost:5004"; // local
// Vue.prototype.$url_service = "http://203.154.32.251:5004" // test
// Vue.prototype.$url_service = "http://10.255.255.10:5004" // test Docker_App_Demosite_SW
// Vue.prototype.$url_service = `${window.location.protocol}//${window.location.hostname}:5004` // test Docker_App_Demosite_SW



Vue.prototype.$thaidate = {
    firstDayOfWeek: 0,
    dayNames: ['อาทิตย์', 'จันทร์', 'อังคาร', 'พุธ', 'พฤหัสบดี', 'ศุกร์', 'อาทิตย์'],
    dayNamesShort: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
    dayNamesMin: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
    monthNames: [
        'มกราคม',
        'กุมภาพันธ์',
        'มีนาคม',
        'เมษายน',
        'พฤษภาคม',
        'มิถุนายน',
        'กรกฎาคม',
        'สิงหาคม',
        'กันยายน',
        'ตุลาคม',
        'พฤศจิกายน',
        'ธันวาคม'
    ],
    monthNamesShort: ['ม.ค.', 'ก.พ.', 'มี.ค.', 'เม.ย.', 'พ.ค.', 'มิ.ย.', 'ก.ค.', 'ส.ค.', 'ก.ย.', 'ต.ค.', 'พ.ย.', 'ธ.ค.'],
    today: 'วันนี้',
    clear: 'เคลียร์',
    dateFormat: 'dd/mm/yy',
    weekHeader: 'Wk'
};

Vue.prototype.$month = [
    { id: '01', name: 'มกราคม', shrt: 'ม.ค.' },
    { id: '02', name: 'กุมภาพันธ์', shrt: 'ก.พ.' },
    { id: '03', name: 'มีนาคม', shrt: 'มี.ค.' },
    { id: '04', name: 'เมษายน', shrt: 'เม.ย.' },
    { id: '05', name: 'พฤษภาคม', shrt: 'พ.ค.' },
    { id: '06', name: 'มิถุนายน', shrt: 'มิ.ย.' },
    { id: '07', name: 'กรกฎาคม', shrt: 'ก.ค.' },
    { id: '08', name: 'สิงหาคม', shrt: 'ส.ค.' },
    { id: '09', name: 'กันยายน', shrt: 'ก.ย.' },
    { id: '10', name: 'ตุลาคม', shrt: 'ต.ค.' },
    { id: '11', name: 'พฤศจิกายน', shrt: 'พ.ย.' },
    { id: '12', name: 'ธันวาคม', shrt: 'ธ.ค.' }
];

Vue.config.productionTip = false;

Vue.component('Accordion', Accordion);
Vue.component('AccordionTab', AccordionTab);
Vue.component('AutoComplete', AutoComplete);
Vue.component('Breadcrumb', Breadcrumb);
Vue.component('Button', Button);
Vue.component('Calendar', Calendar);
Vue.component('Card', Card);
Vue.component('Carousel', Carousel);
Vue.component('Chart', Chart);
Vue.component('Checkbox', Checkbox);
Vue.component('Chips', Chips);
Vue.component('Column', Column);
Vue.component('ColumnGroup', ColumnGroup);
Vue.component('ColorPicker', ColorPicker);
Vue.component('ContextMenu', ContextMenu);
Vue.component('DataTable', DataTable);
Vue.component('DataView', DataView);
Vue.component('DataViewLayoutOptions', DataViewLayoutOptions);
Vue.component('Dialog', Dialog);
Vue.component('Dropdown', Dropdown);
Vue.component('Fieldset', Fieldset);
Vue.component('FileUpload', FileUpload);
Vue.component('FullCalendar', FullCalendar);
Vue.component('InlineMessage', InlineMessage);
Vue.component('InputMask', InputMask);
Vue.component('InputNumber', InputNumber);
Vue.component('InputSwitch', InputSwitch);
Vue.component('InputText', InputText);
Vue.component('Listbox', Listbox);
Vue.component('L', L);
Vue.component('MegaMenu', MegaMenu);
Vue.component('Menu', Menu);
Vue.component('Menubar', Menubar);
Vue.component('Message', Message);
Vue.component('MultiSelect', MultiSelect);
Vue.component('OrderList', OrderList);
Vue.component('OrganizationChart', OrganizationChart);
Vue.component('OverlayPanel', OverlayPanel);
Vue.component('Paginator', Paginator);
Vue.component('Panel', Panel);
Vue.component('PanelMenu', PanelMenu);
Vue.component('Password', Password);
Vue.component('PickList', PickList);
Vue.component('ProgressBar', ProgressBar);
Vue.component('RadioButton', RadioButton);
Vue.component('Rating', Rating);
Vue.component('Row', Row);
Vue.component('SelectButton', SelectButton);
Vue.component('Slider', Slider);
Vue.component('Sidebar', Sidebar);
Vue.component('SplitButton', SplitButton);
Vue.component('Steps', Steps);
Vue.component('TabMenu', TabMenu);
Vue.component('TabView', TabView);
Vue.component('TabPanel', TabPanel);
Vue.component('Textarea', Textarea);
Vue.component('TieredMenu', TieredMenu);
Vue.component('Toast', Toast);
Vue.component('ToastService', ToastService);
Vue.component('Toolbar', Toolbar);
Vue.component('ToggleButton', ToggleButton);
Vue.component('Tree', Tree);
Vue.component('TreeTable', TreeTable);
Vue.component('TriStateCheckbox', TriStateCheckbox);
Vue.component('ProgressSpinner', ProgressSpinner);

import Access from './pages/Access';
import Error from './pages/Error';
import Login from './pages/Login';
import NotFound from './pages/NotFound';
// import { Icon } from 'leaflet'
import 'leaflet/dist/leaflet.css';

import mixin from './mixins/mixins';
Vue.mixin(mixin);

import editor_PDF from './mixins/editor_PDF';
Vue.mixin(editor_PDF);

import editor_PDF_ReportBuildingAmount from './mixins/editor_PDF_ReportBuildingAmount';
Vue.mixin(editor_PDF_ReportBuildingAmount);

new Vue({
    el: '#app',
    computed: {
        ViewComponent() {
            switch (this.$route.path) {
                case '/login':
                    return Login;
                case '/error':
                    return Error;
                case '/access':
                    return Access;
                case '/notfound':
                    return NotFound;
                default:
                    return App;
            }
        }
    },
    router,
    i18n,
    render(h) {
        return h(this.ViewComponent);
    }
});
// npm i  aws-sdk bcrypt compress-base64 cookie-parser cors debug express googleapis http-errors https jade jsonwebtoken morgan multer pg request safe-buffer stream

